<template>
    <div>
        <h1 class="title">Hinweise</h1>
        <p>Bitte nehmen Sie sich ein wenig Zeit und lesen Sie die Hinweise zur Einkommensteuer, Umsatzsteuer und
            sonstigen
            Themen…., sowie zu Rechtsänderungen. Sie erscheinen vier bis fünfmal im Jahr, sind leicht und verständlich
            und
            informieren Sie über das Wichtigste in Kürze. Vielleicht betrifft Sie ein Thema genau? Umfänglichere
            Informationen erhalten Sie gerne auf Anfrage oder in einem Beratungsgespräch.</p>
        <br/>
        <ul>
            <li v-for="hinweis in hinweise" v-bind:key="hinweis.text">
                <a :href="'download/' + hinweis.pdf" v-text="hinweis.text" target="_blank"
                   rel="noopener noreferrer"></a>
                &nbsp;<span class="tag">PDF</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                hinweise: [
                    {
                        text: "Juli 2026",
                        pdf: "Hinweise_Jul_2026.pdf"
                    },            
                    {
                        text: "April 2026",
                        pdf: "Hinweise_Apr_2026.pdf"
                    },                    
                    {
                        text: "Jahreswechsel 2025/2026",
                        pdf: "Hinweise_Dez_2025.pdf"
                    },                    
                    {
                        text: "Oktober 2025",
                        pdf: "Hinweise_Okt_2025.pdf"
                    },            
                    {
                        text: "Juli 2025",
                        pdf: "Hinweise_Jul_2025.pdf"
                    },            
                    {
                        text: "April 2025",
                        pdf: "Hinweise_Apr_2025.pdf"
                    },                    
                    {
                        text: "Jahreswechsel 2024/2025",
                        pdf: "Hinweise_Dez_2024-2025.pdf"
                    },                    
                    {
                        text: "Oktober 2024",
                        pdf: "Hinweise_Okt_2024.pdf"
                    },            
                    {
                        text: "Juli 2024",
                        pdf: "Hinweise_Jul_2024.pdf"
                    },            
                    {
                        text: "April 2024",
                        pdf: "Hinweise_Apr_2024.pdf"
                    },                    
                    {
                        text: "Jahreswechsel 2023/2024",
                        pdf: "Hinweise_Dez_2023-2024.pdf"
                    },                    
                    {
                        text: "Oktober 2023",
                        pdf: "Doleisch_Hinweise_Oktober_2023.pdf"
                    }, 
                    {
                        text: "Juli 2023",
                        pdf: "Doleisch_Hinweise_Juli_2023.pdf"
                    },                                         
                    {
                        text: "April 2023",
                        pdf: "Hinweise_April_2023.pdf"
                    }, 
                    {
                        text: "Jahreswechsel 2022/2023",
                        pdf: "Hinweise_Dez_2022-2023.pdf"
                    }, 
                    {
                        text: "Oktober 2022",
                        pdf: "Hinweise_Oktober_2022.pdf"
                    }, 
                    {
                        text: "Juli 2022",
                        pdf: "Hinweise_Juli_2022.pdf"
                    },                         
                    {
                        text: "April 2022",
                        pdf: "Hinweise_April_2022.pdf"
                    },                     
                    {
                        text: "Jahreswechsel 2021/2022",
                        pdf: " Hinweise_zum_Jahreswechsel_2021-2022.pdf"
                    },                    
                    {
                        text: "Oktober 2021",
                        pdf: "Hinweise_Oktober_2021.pdf"
                    }, 
                    {
                        text: "August 2021",
                        pdf: "Hinweise_August_2021.pdf"
                    },                       
                    {
                        text: "April 2021",
                        pdf: "Hinweise_April_2021.pdf"
                    },                    
                    {
                        text: "Jahreswechsel 2020/2021",
                        pdf: " Hinweise_zum_Jahreswechsel_2020-2021.pdf"
                    },
                    {
                        text: "Oktober 2020",
                        pdf: "Hinweise_Oktober_2020.pdf"
                    },
                    {
                        text: "Juli 2020",
                        pdf: "Hinweise_Juli_2020.pdf"
                    },
                    {
                        text: "April 2020",
                        pdf: "Hinweise_April_2020.pdf"
                    },
                    {
                        text: "Jahreswechsel 2019/2020",
                        pdf: "Hinweise zum Jahreswechsel 2019-2020.pdf"
                    },
                    {
                        text: "Oktober 2019",
                        pdf: "Hinweise Oktober 2019.pdf"
                    },
                    {
                        text: "Juli 2019",
                        pdf: "Hinweise Juli 2019.pdf"
                    }, 
                    {
                        text: "April 2019",
                        pdf: "Hinweise April 2019.pdf"
                    }, 
                    {
                        text: "Jahreswechsel 2018/2019",
                        pdf: "Hinweise zum Jahreswechsel 2018-2019.pdf"
                    },
                    {
                        text: "Oktober 2018",
                        pdf: "Hinweise Oktober 2018.pdf"
                    }, 
                    {
                        text: "Juli 2018",
                        pdf: "Hinweise Juli 2018.pdf"
                    },
                    {
                        text: "Mai 2018",
                        pdf: "Hinweise Mai 2018.pdf"
                    },
                    {
                        text: "Jahreswechsel 2017/2018",
                        pdf: "Hinweise zum Jahreswechsel 2017-2018.pdf"
                    }
                ]
            }
        }
    }
</script>
